import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TransportModeModel } from './transportMode.model';
import { environment } from '../../../../environments/environment';
import { catchError, map } from 'rxjs';

const API_URL = environment.apiUrl
@Injectable({
  providedIn: 'root'
})
export class TransportModeService {

  constructor(private http: HttpClient) {}

  addTransportMode(transportmode: TransportModeModel) {
    
    return this.http.post(API_URL + '/TransportMode/CreateTransportMode', transportmode, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  updateTransportMode(transportmode: TransportModeModel) {
    
    return this.http.put(API_URL + '/TransportMode/UpdateTransportMode', transportmode, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  getAllTransportModes() {
    return this.http.get(API_URL + '/TransportMode/ReadTransportModes', {
      withCredentials: true,
    }).pipe(
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }


  deleteTransportMode(transportmode: TransportModeModel) {
    
    return this.http.delete(API_URL + '/TransportMode/DeleteTransportMode',  {
      headers: {},
      body: transportmode,
      withCredentials: true
   }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }
}
